import { render, staticRenderFns } from "./AddRoleModal.vue?vue&type=template&id=b8b38618&scoped=true"
import script from "./AddRoleModal.vue?vue&type=script&lang=js"
export * from "./AddRoleModal.vue?vue&type=script&lang=js"
import style0 from "./AddRoleModal.vue?vue&type=style&index=0&id=b8b38618&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8b38618",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b8b38618')) {
      api.createRecord('b8b38618', component.options)
    } else {
      api.reload('b8b38618', component.options)
    }
    module.hot.accept("./AddRoleModal.vue?vue&type=template&id=b8b38618&scoped=true", function () {
      api.rerender('b8b38618', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/paycools/system/components/Modal/AddRoleModal.vue"
export default component.exports